module.exports = __webpack_public_path__ + "img/heart.da39ff55.svg";